import { defineComponent as _defineComponent } from 'vue';
import Layout from '@/app/ui/Layout.vue';
import CustomTemplateWithLeftBlock from '@/shared/ui/templates/CustomTemplateWithLeftBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutWithLeftBlockMenu',
  setup: function setup(__props) {
    return {
      __sfc: true,
      Layout: Layout,
      CustomTemplateWithLeftBlock: CustomTemplateWithLeftBlock
    };
  }
});